import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ProductOffers } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const StoreOffersContainer = (props)=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('stores.page.details.offers.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(ProductOffers, swcHelpers.extends({}, props, {
        labels: labels
    }));
};
var StoreOffers = StoreOffersContainer;

export { StoreOffers as default };
//# sourceMappingURL=StoreOffersContainer.js.map
